// crewbit-admin/src/components/money/InvoicesSummaryStrip.tsx
//
// 4-card hero strip for the admin /money/invoices page. Maps verbatim from
// useInvoices().summary: Outstanding $X / Overdue $Y / Paid this month $Z /
// Total invoices N. Display-only.
//
// SPEC: §Money.InvoicesListAdmin §3 (D8).

import { MetricCard } from '../common/MetricCard';
import { palette, spacing, urgency } from '../../styles/tokens';
import { formatMoney } from '../../lib/money';

interface InvoicesSummary {
  totalOutstanding: number;
  totalOverdue: number;
  totalPaidThisMonth: number;
  invoiceCount: number;
  overdueCount: number;
}

interface InvoicesSummaryStripProps {
  summary: InvoicesSummary;
}

export function InvoicesSummaryStrip({ summary }: InvoicesSummaryStripProps) {
  const overdueSub = summary.overdueCount === 1 ? '1 invoice' : `${summary.overdueCount} invoices`;
  return (
    <div style={{ display: 'flex', gap: spacing.md, flexWrap: 'wrap' }}>
      <MetricCard
        label="Outstanding"
        value={formatMoney(summary.totalOutstanding)}
      />
      <MetricCard
        label="Overdue"
        value={formatMoney(summary.totalOverdue)}
        valueColor={summary.totalOverdue > 0 ? palette.red : undefined}
        sub={summary.totalOverdue > 0 ? overdueSub : undefined}
      />
      <MetricCard
        label="Paid this month"
        value={formatMoney(summary.totalPaidThisMonth)}
        valueColor={summary.totalPaidThisMonth > 0 ? urgency.info : undefined}
      />
      <MetricCard
        label="Total invoices"
        value={String(summary.invoiceCount)}
      />
    </div>
  );
}
